import { http, uploadFile } from '@/utils/axios'

/**
 * @msg: 判定账号密码
 */
export function vialUser(data) {
    return http({
        url: http.baseUrl('zkolThirdPartyUserRef/vialUser'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 绑定公众号
 */
export function bindUser(data) {
    return http({
        url: http.baseUrl('zkolThirdPartyUserRef/bindUser'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 签到
 */
export function sign(data) {
    return http({
        url: http.baseUrl('zkolSignRecord/sign'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 获取签到信息
 */
export function getSignRecord(data) {
    return http({
        url: http.baseUrl('zkolSignRecord/getSignRecord'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 获取签退信息
 */
export function getSignOutRecord(data) {
    return http({
        url: http.baseUrl('zkolSignOut/getSignRecord'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 获取评语列表
 */
export function getContentList(data) {
    return http({
        url: http.baseUrl('zkolSignOut/getContentList'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 更新签退评分
 */
export function updateSignOut(data) {
    return http({
        url: http.baseUrl('zkolSignOut/updateSignOut'),
        method: 'post',
        params: http.params(data)
    })
}
/**
 * @msg: 签退
 */
export function signOut(data) {
    return http({
        url: http.baseUrl('zkolSignOut/signOut'),
        method: 'post',
        params: http.params(data)
    })
}